<template>
  <div class="site-url">
    <a-input
      v-model="url"
      @pressEnter="handleAdd"
      :placeholder="placeholder"
    >
      <a-icon @click="handleAdd" class="add btn" slot="suffix" type="plus-circle" />
    </a-input>
    <ul class="list" v-if="urls.length > 0">
      <li class="ellipsis" v-for="(item, index) in urls" :key="index">
        <span>{{ item }}</span>
        <a-icon
          class="delete-btn"
          @click="handleDelete(index)"
          type="minus-circle"
          theme="filled"
        />
      </li>
    </ul>
  </div>
</template>
<script>
import _ from 'lodash'
export default {
  data() {
    return {
      url: '',
      urls: []
    }
  },
  props: {
    placeholder: {
      type: String,
      default: function () {
        return '内容'
      }
    },
    value: {
      type: Array,
      default: function () {
        return []
      }
    },
    dataChange:{
      type:Function
    }
  },

  methods: {
    handleAdd() {
      if (this.url.trim() != '') {
        if (this.urls.includes(this.url)) {
          this.$message.error(this.placeholder + '重复!')
          return
        }
        this.urls.push(this.url)
        this.url = ''
        this.$emit('input', _.cloneDeep(this.urls))
        this.dataChange(this.urls)
      } else {
        this.$message.error(this.placeholder + '，不能为空!')
      }
    },

    handleDelete(index) {
      this.urls.splice(index, 1)
      this.$emit('input', _.cloneDeep(this.urls))
      this.dataChange(this.urls)
    }
  },
  watch: {
    value: {
      handler() {
        this.urls = _.cloneDeep(this.value)
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="less" scoped>
.site-url {
  .add {
    cursor: pointer;
    position: absolute;
    right: -38px;
    font-size: 16px;
  }
  .list-wrap {
    height: 150px;
  }
  .list {
    border: 1px solid #e2e2e2;
    border-radius: 2px;
    position: relative;
    top: -0px;
    max-height: 98px;
    overflow: auto;

    li {
      height: 32px;
      line-height: 32px;
      padding: 0 3px 0px 10px;
      position: relative;

      &:hover {
        background: #ebf2ff;
      }

      i {
        position: absolute;
        right: 0;
        top: 0;
        width: 30px;
        height: 30px;
        line-height: 30px;
        cursor: pointer;
        display: none;
      }
      &:hover {
        i {
          display: block;
        }
      }
      &:last-child {
        border-bottom: none;
      }
    }
  }
  .btn {
    color: #1890ff;
  }

  .delete-btn {
    color: #ed7878;
    transform: translateY(3px);
  }
}
</style>
